import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { RequestTypeDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-requesttype',
  templateUrl: './requesttype.component.html',
  styleUrls: ['./requesttype.component.scss']
})
export class RequesttypeComponent implements OnChanges {

  requestTypeForm: FormGroup;
  requestTypeFormArray: FormGroup;
  control = new FormControl();
  @Input() requestTypes: RequestTypeDto[];
  @Input() routeAnimationsElements: any;
  @Output() requestType = new EventEmitter<RequestTypeDto[]>()
  @Output() deleteRequestTypeEvent = new EventEmitter<any>()

    selectedRequestTypek: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnChanges() {
      this.createRequestTypeForm();
    }

    createRequestTypeForm() {
      this.requestTypeForm = this.fb.group({
        RequestTypeName: ['', Validators.required],
        id: null
        });
        this.requestTypeFormArray = this.fb.group({ RequestTypes: this.fb.array([])
          });
        this.setRequestType();
    }

  // method to display requestTypes
  setRequestType() {
    const control  = this.requestTypeFormArray.controls.RequestTypes as FormArray;
    this.requestTypes.forEach( e => {
      control.push(
        this.fb.group({
          RequestTypeName: e.RequestTypeName,
          id: e.id
        })
      );
    });
  }


  // method to add requestType
  addRequestType(value: RequestTypeDto) {
    const control  = this.requestTypeFormArray.controls.RequestTypes as FormArray;
    control.insert(0,
          this.fb.group({
            RequestTypeName: value.RequestTypeName,
            id: null
          })
       );
  }

  selectRequestType(value) {}

  // method to delete requestType from arrary list
  deleteRequestType(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.requestTypeFormArray.controls.RequestTypes as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.requestTypes.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.requestTypes[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: RequestTypeDto) {
    if(this.requestTypeForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.requestTypeFormArray.get('RequestTypes')['controls'][this.selectedIndex].patchValue({RequestTypeName: formValue.RequestTypeName});
    } else {
      this.addRequestType(formValue);
    }
    this.selectedIndex = null;
    this.requestTypeForm.reset()
  }

  onEdit(index, value: RequestTypeDto) {
    console.log(index, value)
    this.selectedIndex = index;
    this.requestTypeForm.patchValue({RequestTypeName: value.RequestTypeName});
  }

  onClearForm() {
    this.selectedIndex = null;
    this.requestTypeForm.reset();
  }

  onSubmit(formValue: RequestTypeDto[]) {
    console.log("Checking Action Party", formValue);
  this.requestType.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteRequestTypeEvent.emit(this.filteredDelete);
  }
  }


}
